module.exports = __webpack_public_path__ + "img/CloudOutlined.c058cc6f.svg";